// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"526":"donate","594":"about"}[chunkId] + "." + {"526":"9f81edf1","594":"027227d2"}[chunkId] + ".js";
};